export default "__VITE_ASSET__CKWQN3PF__"